/**
 * Hub-page indexability threshold — 2026-06-13.
 *
 * A blog hub page (topic, difficulty level, or tag) is INDEXABLE if and only
 * if it lists at least HUB_INDEX_MIN_POSTS posts. Pages below the threshold:
 *   - are excluded from the XML sitemap (scripts/generate-sitemap.mts)
 *   - emit `noindex, follow` at runtime via SEOService
 *
 * Evidence (Google Search Console, June 2026):
 *   - Topic `gear-and-setup` has zero posts → soft-404 logged in GSC.
 *   - 58 of 82 tag pages have fewer than 3 posts → consistently
 *     discovered-but-not-indexed by Googlebot (thin-content signal).
 * Three posts is the minimum threshold for meaningful content density.
 */
export const HUB_INDEX_MIN_POSTS = 3;

/**
 * Returns true when a hub page with the given post count should be indexed
 * by search engines and included in the sitemap.
 */
export function isHubIndexable(postCount: number): boolean {
  return postCount >= HUB_INDEX_MIN_POSTS;
}
